// BARRE DE RECHERCHE
const searchBar = document.querySelector('form.search-form');
const searchToggler = document.getElementById('search-toggler');

searchToggler.addEventListener('click', function(e) {
    e.stopImmediatePropagation();

    if (searchBar.classList.contains('search--opened') && this.classList.contains('search-toggler--opened')) {
        searchBar.classList.remove('search--opened');
        this.classList.remove('search-toggler--opened');
        this.setAttribute('aria-label', 'false');
    } else {
        searchBar.classList.add('search--opened');
        this.classList.add('search-toggler--opened');
        this.setAttribute('aria-label', 'true');
    }
});